<template>
	<div>
		<div class="table">
			<table width="100%" cellpadding="0" cellspacing="0">
				<thead>
					<tr>
						<th width="5%">序号</th>
						<th :width="item.thWidth" v-for="item in theadTh" :key="item.index">{{item.name}}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(td,index) in tbodyTd" :key="index">
						<td>{{index+1}}</td>
						<td v-for="item in theadTh" :key="item.index">
								<p v-html="td[item.value]"></p>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
export default {
  name: '',
  components: {
  },
  props: {
  	thWidth:String,
    theadTh: {
      type: Array
    },
    tbodyTd: {
      type: Array
	},
	childType:String,
    paneShow: Boolean
  },
  data () {
    return {
      paging: [], // 存储数据,
      showList: [],
    }
  },
  created () {
	  this.getList()
  },
  methods: {
	getList () {
		for( let i;  i<this.tbodyTd;i++) {
			if (this.tbodyTd && i<this.tbodyTd.length) {
				console.log(this.childType)
				if(this.childType){
					for(let key in this.tbodyTd[i]){
						console.log(key)
						console.log(this.tbodyTd[i])
						if(this.tbodyTd[i].key instanceof Array){
							this.tbodyTd[i].key=this.tbodyTd[i].key[0][this.childType]
						}
					}
				}else{
				this.showList.push(this.tbodyTd[i])
				}
			}
			}
		},
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
	.table {
		width: 100%;
		table {
			text-align: center;
			color: #666;
			font-size: 16px;
			border: 1px solid #ccc;
			border-bottom: none;
			th {
				height: 46px;
				line-height: 46px;
				text-align: center;
				color: #000;
				font-weight:bold;
				background: #f5f5f5;
				border-bottom: 1px solid #ccc;
				&:not(:last-child) {
					border-right: 1px solid #ccc;
				}
			}
			tbody {
				tr {
					border-bottom: 1px solid #ccc;
					td {
						padding: 10px;
						font-size: 14px;
						word-wrap:break-word;
						white-space:normal;
						word-break:break-all;
						&:not(:last-child) {
							border-right: 1px solid #ccc;
						}
						span {
						&.orange{
								color:#ff3b30;
							}
							&.blue{
								color:#1e90ff;
							}
							&:not(:last-child){
								margin-right:10px;
							}
							&.opertBtn{
								cursor:pointer;
							}
						}
						.haveImg{
							img{
								margin-right:10px;
							}
							span{
								&:not(:last-child){
									margin-right:10px;
								}
							}
						}
					}
				}
			}
		}
	}
	
	
</style>
